import React, { useEffect, useState } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';

// horizontal settings tab
function SettingsTab({ to, label, pathName }) {
  const isActive = pathName === to;
  return (
    <Link
      to={to}
      className={`px-3.5 py-2.5 text-sm whitespace-nowrap border-b-2 -mb-px transition-colors ${
        isActive
          ? 'border-surface-900 text-surface-900 font-semibold'
          : 'border-transparent text-surface-500 font-medium hover:text-surface-700 hover:border-surface-300'
      }`}
    >
      {label}
    </Link>
  );
}

function Settings({ connectionData, integrationLists, integrationListsLoading }) {
  const [pathName, setPathName] = useState(null);
  const location = useLocation();
  const { orgRole } = useAuth();

  useEffect(() => {
    if (location.pathname.includes('settings')) {
      const temp = location.pathname.split('/').pop();
      setPathName(temp);
    }
  }, [location]);

  return (
    <div className="page-container">
      <div className="flex items-baseline gap-3">
        <h1 className="page-title">Settings</h1>
        <span className="page-subtitle">Manage your team, integrations, and billing</span>
      </div>
      {/* Horizontal tab bar */}
      <nav className="flex flex-wrap gap-1 border-b border-surface-200 flex-shrink-0">
        <SettingsTab to="users" label="Users" pathName={pathName} />
        <SettingsTab to="api-keys" label="API Keys" pathName={pathName} />
        <SettingsTab to="connection-settings" label="Connections" pathName={pathName} />
        <SettingsTab to="branding" label="Branding" pathName={pathName} />
        <SettingsTab to="magic-links" label="Magic Links" pathName={pathName} />
        <SettingsTab to="notifications" label="Notifications" pathName={pathName} />
        {orgRole === 'admin' && (
          <SettingsTab to="usage-billing" label="Usage & Billing" pathName={pathName} />
        )}
      </nav>
      {/* Content Area. reserve the scrollbar gutter so switching to a taller tab
          (its scrollbar appears) doesn't shift content width. */}
      <div className="flex-1 min-h-0 overflow-y-auto [scrollbar-gutter:stable]">
        <Outlet context={{ connectionData, integrationLists, integrationListsLoading }} />
      </div>
    </div>
  );
}

export default Settings;
